/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { FaqItem } from './FaqItem'
import { FaqItemFromJSON, FaqItemFromJSONTyped, FaqItemToJSON } from './FaqItem'

/**
 *
 * @export
 * @interface GetFaqList200ResponseData
 */
export interface GetFaqList200ResponseData {
  /**
   * Вопросы с ответами (элементы — схема FaqItem, единая с faq[] инструкции)
   * @type {Array<FaqItem>}
   * @memberof GetFaqList200ResponseData
   */
  faq: Array<FaqItem>
}

/**
 * Check if a given object implements the GetFaqList200ResponseData interface.
 */
export function instanceOfGetFaqList200ResponseData(
  value: object
): value is GetFaqList200ResponseData {
  if (!('faq' in value) || value['faq'] === undefined) return false
  return true
}

export function GetFaqList200ResponseDataFromJSON(
  json: any
): GetFaqList200ResponseData {
  return GetFaqList200ResponseDataFromJSONTyped(json, false)
}

export function GetFaqList200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetFaqList200ResponseData {
  if (json == null) {
    return json
  }
  return {
    faq: (json['faq'] as Array<any>).map(FaqItemFromJSON),
  }
}

export function GetFaqList200ResponseDataToJSON(
  value?: GetFaqList200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    faq: (value['faq'] as Array<any>).map(FaqItemToJSON),
  }
}
